import { PORTING_SUB_ORDER_ID, TERMINATION_SUB_ORDER_ID } from './consts'
import type { PortingOrder, SubOrder, TerminationOrder, UpgradeOrder } from './resources'

export type OrderType = 'porting' | 'termination' | 'upgrade'
export type OrderStatusOriginal =
  | 'FOR_MANUAL_HANDLING'
  | 'OPEN'
  | 'ALL'
  | 'WAITING_FOR_USER'
  | 'WAITING_FOR_DEALER'
  | 'PROCESSING'
  | 'TERMINATED'
  | 'TERMINATION_REQUEST'
  | 'DONE'
  | 'CANCELED'
  | 'FAILED'
export type CommonOrderKeys = keyof PortingOrder | keyof TerminationOrder | keyof UpgradeOrder

export function isPortingOrder(order: Omit<SubOrder, 'status'>): order is PortingOrder {
  return (order as Omit<SubOrder, 'status'>).subscriptionServiceId === PORTING_SUB_ORDER_ID
}
export function isTerminationOrder(order: Omit<SubOrder, 'status'>): order is TerminationOrder {
  return (order as Omit<SubOrder, 'status'>).subscriptionServiceId === TERMINATION_SUB_ORDER_ID
}
export function isUpgradeOrder(order: Omit<SubOrder, 'status'>): order is UpgradeOrder {
  return (
    (order as SubOrder).subscriptionServiceId !== TERMINATION_SUB_ORDER_ID &&
    (order as SubOrder).subscriptionServiceId !== PORTING_SUB_ORDER_ID
  )
}

export type SubscriptionOrderOriginal = {
  id: number
  price: number
  status: number
  comment: string | null
  subscription_service_id: number | null
  order_date: string
  order_update: string
  dealer_comment: string | null
  user_comment: string | null
  currency: string | null
  api_supplier_order_status: string | null
  api_supplier_carrier_id: number | null
  api_order_id: string | null
  subscription_service_name: string | null
  org_no: string | null
  customer: string | null
  user: string | null
  code: string | null
  subStatus: OrderStatusOriginal
}

export type PortingOrderOriginal = SubscriptionOrderOriginal & {
  activation_number: string | null
  is_new_number: boolean | null
  activation_user_submission: string
  is_business_sub: boolean | null
  ssoa_id: number | null
  activation_date: string
  days_to_activation: number | null
  document_id: number | null
}

export type UpgradeOrderOriginal = SubscriptionOrderOriginal

export type TerminationOrderOriginal = SubscriptionOrderOriginal & {
  termination_type_id: number | null
  termination_user_submission: string
  termination_date: string
  days_to_termination: number | null
  birth_date_org_no: string | null
  credit_check_acceptance_given: string
}
